export const root = "r19z8aar";
export const container = "cknu8rs";
export const logo = "l1cpjdz";
export const title = "te1wt2g";
export const description = "d16t2shi";
export const button = "b1icp504";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");